import { useState } from 'react';

import { SUGGESTED_ANSWER_VARY } from 'global/constants';
import SubActivityView from '../../sub-activity/sub-activity-view';
import ActivitySheet from '../../shared/sheet/activity-sheet';
import {
  ActivitySheetInnerContent,
  ActivitySheetInnerMax,
} from '../../shared/sheet/activity-sheet.style';
import { ClassroomAnswerInstruction } from '../../../classroom/classroom-answer.style';
import ClassroomAnswerTabs, {
  QUESTION_VIEW,
  SUGGESTED_VIEW,
} from 'approot/activity-builder/classroom/classroom-answer-tabs';
import { ViewProps } from '../fill-in-blanks.constants';
import { SampleProps } from '../../sample/activity-sample.constants';
import FillInBlanksSuggestedAnswers from '../teacher/fill-in-blanks-suggested-answers';
import FillInBlanksViewContent from '../fill-in-blanks-view-content';

type Props = ViewProps &
  SampleProps & {
    onClose: () => void;
  };

const FillInBlanksSampleClassAnswers = (props: Props) => {
  const {
    id,
    type,
    subActivityProperties,
    suggestedAnswerProperties,
    banner,
    onClose,
  } = props;

  const [tab, setTab] = useState<string>(QUESTION_VIEW);

  return (
    <ActivitySheet
      isVisible
      title="Fill in the Blanks"
      hasBackgroundColor={tab === QUESTION_VIEW}
      onClose={onClose}
      banner={banner}
      tabsContent={
        <ClassroomAnswerTabs
          isPublished
          canClearModelledResponse={false}
          includeIndividualAnswers={false}
          includeClassResponse={false}
          includeSuggestedAnswers={
            !!(
              suggestedAnswerProperties?.suggestedAnswerType ===
                SUGGESTED_ANSWER_VARY ||
              (suggestedAnswerProperties?.suggestedAnswers &&
                suggestedAnswerProperties.suggestedAnswers.length > 0)
            )
          }
          tab={tab}
          onSelect={option => setTab(option)}
          componentId={id}
          onCloseActivitySheet={onClose}
        />
      }
    >
      <ActivitySheetInnerContent id="content">
        {tab === QUESTION_VIEW &&
          subActivityProperties?.activityComponentId && (
            <ActivitySheetInnerMax>
              <ClassroomAnswerInstruction>
                <SubActivityView
                  withTTSButton
                  componentId={id}
                  componentType={type}
                  subActivityDetails={subActivityProperties}
                >
                  <FillInBlanksViewContent {...props} updateAnswer={() => {}} />
                </SubActivityView>
              </ClassroomAnswerInstruction>
            </ActivitySheetInnerMax>
          )}
        {tab === SUGGESTED_VIEW && (
          <ActivitySheetInnerMax>
            <FillInBlanksSuggestedAnswers {...props} />
          </ActivitySheetInnerMax>
        )}
      </ActivitySheetInnerContent>
    </ActivitySheet>
  );
};

export default FillInBlanksSampleClassAnswers;
